export default {
  namespaced: true,
  state: {
    loading: 0,
    intLoading: false
  },
  getters: {
    loading: state => state.loading,
    intLoading: state => state.intLoading
  },
  mutations: {
    startLoading: state => state.loading++,
    finishLoading: state => state.loading--,
    startIntLoading: state => { state.intLoading = true },
    stopIntLoading: state => { state.intLoading = false }
  },
  actions: {
    stopIntLoading ({ commit }) {
      setTimeout(() => {
        commit('stopIntLoading')
      }, 1000)
    }
  }
}
